import data from './data'

export default {
  data,
  resourcePath: '/v1/professional/settings/terms'
}



// WEBPACK FOOTER //
// ./src/app/professional/terms/index/resources/index.js